/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
@Injectable()
export class CantonsService  {
  cantons: any[];
  onCantonsChanged: BehaviorSubject<any> = new BehaviorSubject({});
  countryId = '';
  addSuccess = false;
  updateSuccess = false;
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.countryId = '',
        this.getCantons()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getCantons () {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/city/cities?countryId=' + this.countryId  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.cantons = response;
          this.onCantonsChanged.next(this.cantons);
          resolve(response);
        }, reject);
    });

  }

  getCantonsById(id) {
    return this.http.get(this.api.baseUrl + '/city/city?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteCanton(id) {
    return this.http.delete(this.api.baseUrl + '/city/deleteCity?id=' + id , this.api.jsonTokenHeaders);
  }

  addCanton(data) {
    const formData: FormData = new FormData();
    formData.append('file', data.file);
    formData.append('name', data.name);
    formData.append('code', data.code);
    formData.append('countryId', data.countryId);
    formData.append('welcomeText', data.welcomeText);
    if (data.id) {
      formData.append('id', data.id);
    }
    return this.http.post(this.api.baseUrl + '/city/addCity' , formData , this.api.formDataHeaders);
  }
  getCountry() {
    return this.http.get(this.api.baseUrl + '/country/countries', this.api.jsonTokenHeaders);
  }

  setCountryId(id) {
    this.countryId = id;
  }

  getCityForMergeTool() {
    return this.http.get(this.api.baseUrl + '/city/cityMergeTool', this.api.jsonTokenHeaders);
  }

  getMergeSettings() {
    return this.http.get(this.api.baseUrl + '/mergeSetting/mergeSettings', this.api.jsonTokenHeaders);
  }

  addMergeSetting(data) {
    return this.http.post(this.api.baseUrl + '/mergeSetting/addMergeSetting' , data , this.api.jsonTokenHeaders);
  }
}
